import Axios from 'axios'
import config from '@/config/config.js'

const baseUrl = config.apiDomain.ALI + '/ext/ws/box/'
const submitBoxMessageUrl = baseUrl + 'submitBoxMessage'

Axios.defaults.headers.timeout = 8000

export default {

  submitBoxMessage (form, cb) {
    Axios.post(submitBoxMessageUrl, form).then(
      response => {
        cb(response)
      }
    ).catch(error => {
      console.log(error)
      cb(error.response)
    })
  }

}
